<div class="profile-container" *ngIf="data.fromwhere == 'userprofile'">
    <div class="header">
      <h2 class="heading">Edit User Details</h2>
  
      <mat-icon (click)="canceledit()" style="cursor: pointer">close</mat-icon>
    </div>
    <div class="profile-card">
      <!-- Left Panel (Profile Picture and Sidebar) -->
      <div class="profile-sidebar">
        <div class="profile-pic">
          <img
            *ngIf="!userinfo.photoURL"
            src="./../../../assets/avatar.png"
            alt="Profile Picture"
          />
          <img
            *ngIf="userinfo.photoURL"
            [src]="userinfo.photoURL"
            alt="Profile Picture"
          />
  
          <div
            class="profile-pic-overlay"
          >
            Click to change photo
          </div>
        </div>
        <div class="profile-menu">
          <ul>
            <li class="active">Personal Details</li>
            <!-- <li>Account type</li> -->
            <!-- <li>Payments</li> -->
          </ul>
        </div>
      </div>
  
      <!-- Right Panel (Account Details Form) -->
      <div class="profile-details">
        <!-- <h2>Personal Details</h2> -->
        <form #reqform="ngForm" autocomplete="off">
          <div class="form-group">
            <label>First Name<span style="color: red"> * </span>:</label>
            <input
              type="text"
              placeholder="Felecia"
              required
              type="text"
              placeholder="Your Company name"
              id="firstname"
              name="firstname
                  "
              [(ngModel)]="userinfo.firstname"
              [required]="true"
              #firstName="ngModel"
              pattern="^[^\s]+.*$"
              maxlength="30"
            />
          </div>
          <mat-error
            style="font-size: 15px"
            *ngIf="firstName.errors?.['required'] && (firstName.touched || firstName.dirty)"
          >
            First name is required.
          </mat-error>
  
          <div class="form-group">
            <label>Last Name<span style="color: red"> * </span>:</label>
            <input
              type="text"
              placeholder="Felecia"
              required
              type="text"
              placeholder="Your Company name"
              id="lastname"
              name="lastname
              "
              [(ngModel)]="userinfo.lastname"
              [required]="true"
              #lastName="ngModel"
              pattern="^[^\s]+.*$"
              maxlength="30"
            />
          </div>
          <mat-error
            style="font-size: 15px"
            *ngIf="firstName.errors?.['required'] && (firstName.touched || firstName.dirty)"
          >
            Last name is required.
          </mat-error>
          <!-- <div class="form-group">
                    <label>Email<span style="color: red"> * </span>:</label>
                    <input type="text" placeholder="Burke" required         type="text"
                    id="companyemail"
                    name="companyemail"
                    [(ngModel)]="userinfo.emailid"
                    [required]="true"
                    required
                    pattern=".+@.+\..+"
                    #emailid="ngModel"
                  />
                  <mat-error
                    *ngIf="
                emailid.invalid && (emailid.touched || emailid.dirty) && !emailid.errors?.['pattern']
              "
                  >
                    Company email id is required.
                  </mat-error>
                  <mat-error *ngIf="emailid.errors?.['pattern']">
                    Please enter a valid email id.
                  </mat-error>
                </div> -->
          <div class="form-group">
            <label>Address</label>
            <textarea
              style="
                width: 100%;
                padding: 5px 10px;
                border: 1px solid #d7d7d7;
                height: 80px;
                border-radius: 5px;
                font-size: 15px;
                background-color: #fbfbfb;
                color: #262626;
                outline: none;
              "
              id="address"
              name="address"
              placeholder="Your office address"
              #Address="ngModel"
              [required]="true"
              [(ngModel)]="userinfo.address1"
            ></textarea>
            <mat-error
              style="font-size: 15px; margin-left: 1%"
              *ngIf="Address.errors?.['required'] && (Address.touched || Address.dirty)"
            >
              Address is required.
            </mat-error>
          </div>
  
          <div class="form-group">
            <label>City :</label>
            <input
              style="
                margin: 0;
                width: 100%;
                background-color: #fbfbfb;
                padding: 5px 10px;
                border-radius: 5px;
                border: 1px solid #d4d4d4;
                position: relative;
                color: black;
              "
              type="text"
              placeholder="Ex:3000"
              id="sqftrate"
              name="sqftrate"
              [(ngModel)]="userinfo.city"
              #City="ngModel"
            />
          </div>
  
          <div class="form-group">
            <label>State :</label>
            <input
              style="
                margin: 0;
                width: 100%;
                background-color: #fbfbfb;
                padding: 5px 10px;
                border-radius: 5px;
                border: 1px solid #d4d4d4;
                position: relative;
                color: black;
              "
              type="text"
              placeholder="Ex:3000"
              id="state"
              name="state"
              [(ngModel)]="userinfo.state"
              #State="ngModel"
            />
          </div>
          <!-- <div class="form-group">
                    <label>Date of Birth (Optional):</label>
                    <div class="dob-container">
                        <select>
                            <option>10</option>
                        </select>
                        <select>
                            <option>June</option>
                        </select>
                        <select>
                            <option>1990</option>
                        </select>
                    </div>
                </div> -->
          <div class="form-group">
            <label>Phone Number:</label>
            <input
              type="number"
              id="phone"
              name="phone"
              min="0"
              [(ngModel)]="userinfo.phoneNumber"
              [required]="true"
              #phoneNum="ngModel"
              pattern="^((\\+91-?)|0)?[0-9]{10}$"
              placeholder="Ex: +91 949596 9294"
            />
  
            <mat-error
              style="font-size: 15px; margin-left: 1%"
              *ngIf="phoneNum.errors?.['required'] && (phoneNum.touched || phoneNum.dirty)"
            >
              Phone number is required.
            </mat-error>
  
            <mat-error *ngIf="phoneNum.errors?.['pattern']">
              Please enter a valid phone number.
            </mat-error>
          </div>
  
          <button
            type="submit"
            class="btn-update"
            (click)="saveEditdetails(reqform)"
          >
            Update
          </button>
        </form>
      </div>
    </div>
  </div>
  
  <div class="profile-container" *ngIf="data.fromwhere == 'companyprofile'">
    <div class="header">
      <h2 class="heading">Edit Company Details</h2>
  
      <mat-icon (click)="canceledit()" style="cursor: pointer">close</mat-icon>
    </div>
    <div class="profile-card">
      <!-- Left Panel (Profile Picture and Sidebar) -->
      <div class="profile-sidebar">
        <div class="profile-pic">
          <img
          *ngIf="!userinfo.accountdetails.companylogimage"
          src="./../../../assets/avatar.png"
          alt="Profile Picture"
        />
        <img
          *ngIf="userinfo.accountdetails.companylogimage"
          [src]="userinfo.accountdetails.companylogimage"
          alt="Profile Picture"
        />
  
        <div
          class="profile-pic-overlay"
        
        >
          Click to change photo
        </div>
        </div>
        <div class="profile-menu">
          <ul>
            <li class="active">Account Details</li>
            <!-- <li>Account type</li> -->
            <!-- <li>Payments</li> -->
          </ul>
        </div>
      </div>
  
      <!-- Right Panel (Account Details Form) -->
      <div class="profile-details">
        <!-- <h2>Account Details</h2> -->
        <form #reqform="ngForm" autocomplete="off">
          <div class="form-group">
            <label>Company Name<span style="color: red"> * </span>:</label>
            <input
              type="text"
              placeholder="Felecia"
              required
              type="text"
              placeholder="Your Company name"
              id="companyname"
              name="companyname
                  "
              [(ngModel)]="userinfo.accountdetails.companyname"
              [required]="true"
              required
              #companyName="ngModel"
              pattern="^[^\s]+.*$"
              maxlength="30"
            />
          </div>
          <mat-error
            style="font-size: 15px"
            *ngIf="companyName.errors?.['required'] && (companyName.touched || companyName.dirty)"
          >
            Company name is required.
          </mat-error>
          <div class="form-group">
            <label>Company email<span style="color: red"> * </span>:</label>
            <input
              type="text"
              placeholder="Burke"
              required
              type="text"
              id="companyemail"
              name="companyemail"
              [(ngModel)]="userinfo.accountdetails.officeemailid"
              [required]="true"
              required
              pattern=".+@.+\..+"
              #emailid="ngModel"
            />
            <mat-error
              *ngIf="
                emailid.invalid && (emailid.touched || emailid.dirty) && !emailid.errors?.['pattern']
              "
            >
              Company email id is required.
            </mat-error>
            <mat-error *ngIf="emailid.errors?.['pattern']">
              Please enter a valid email id.
            </mat-error>
          </div>
          <div class="form-group">
            <label>Company address</label>
            <textarea
              style="
                width: 100%;
                padding: 5px 10px;
                border: 1px solid #d7d7d7;
                height: 80px;
                border-radius: 5px;
                font-size: 15px;
                background-color: #fbfbfb;
                color: #262626;
                outline: none;
              "
              id="officeaddress"
              name="officeaddress"
              placeholder="Your office address"
              #officeAddress="ngModel"
              [required]="true"
              required
              [(ngModel)]="userinfo.accountdetails.officeaddress"
            ></textarea>
            <mat-error
              style="font-size: 15px; margin-left: 1%"
              *ngIf="officeAddress.errors?.['required'] && (officeAddress.touched || officeAddress.dirty)"
            >
              Address is required.
            </mat-error>
          </div>
          <!-- <div class="form-group">
                    <label>Date of Birth (Optional):</label>
                    <div class="dob-container">
                        <select>
                            <option>10</option>
                        </select>
                        <select>
                            <option>June</option>
                        </select>
                        <select>
                            <option>1990</option>
                        </select>
                    </div>
                </div> -->
          <div class="form-group">
            <label>Phone Number:</label>
            <input
              type="number"
              id="officephone"
              name="officephone"
              min="0"
              [(ngModel)]="userinfo.accountdetails.officephone"
              [required]="true"
              required
              #officephone="ngModel"
              pattern="^((\\+91-?)|0)?[0-9]{10}$"
              placeholder="Ex: +91 949596 9294"
            />
  
            <mat-error
              style="font-size: 15px; margin-left: 1%"
              *ngIf="officephone.errors?.['required'] && (officephone.touched || officephone.dirty)"
            >
              Phone number is required.
            </mat-error>
  
            <mat-error *ngIf="officephone.errors?.['pattern']">
              Please enter a valid  Phone number.
            </mat-error>
          </div>
  
          <div class="form-group">
            <label>Company started year</label>
            <mat-select
              style="
                margin: 0;
                width: 100%;
                background-color: #fbfbfb;
                padding: 5px 10px;
                border-radius: 5px;
                border: 1px solid #d4d4d4;
                position: relative;
                color: black;
              "
              id="companyfoundYear"
              name="companyfoundYear"
              [(ngModel)]="userinfo.accountdetails.companyfoundyear"
              #companyfoundYear="ngModel"
              maxlength="50"
              placeholder="Select Year"
            >
              <mat-option *ngFor="let year of years" [value]="year">{{
                year
              }}</mat-option>
            </mat-select>
            <mat-error
              *ngIf="companyfoundYear.errors?.['required'] && (companyfoundYear.touched || companyfoundYear.dirty)"
            >
              Year is required .
            </mat-error>
          </div>
          <!-- <div class="form-group" *ngIf="userinfo?.businesstype == 'contract'">
            <label>Starting rate/sq ft(in Rupees) :</label>
            <input
              style="
                margin: 0;
                width: 100%;
                background-color: #fbfbfb;
                padding: 5px 10px;
                border-radius: 5px;
                border: 1px solid #d4d4d4;
                position: relative;
                color: black;
              "
              type="number"
              placeholder="Ex:3000"
              id="sqftrate"
              name="sqftrate"
              [(ngModel)]="userinfo.accountdetails.sqfeetrate"
              [required]="true"
              #sqftRate="ngModel"
             
              min="0"
            />
            <mat-error
              style="font-size: 15px; margin-left: 1%"
              *ngIf="sqftRate.errors?.['required'] && (sqftRate.touched || sqftRate.dirty)"
            >
              Sq ft rate is required.
            </mat-error>
          </div> -->
  
          <!-- <div class="form-group" *ngIf="userinfo?.businesstype == 'contract'">
            <label>Service provided<span style="color: red">*</span>:</label>
            <div
              style="
                margin: 0;
                width: 100%;
                background-color: #fbfbfb;
                padding: 5px 10px;
                border-radius: 5px;
                border: 1px solid #d4d4d4;
                position: relative;
                color: black;
              "
            >
              <mat-select
                style="height: inherit"
                id="companyservice"
                name="companyservice"
                [(ngModel)]="userinfo.accountdetails.companyservice"
                #companyservice="ngModel"
                maxlength="50"
                [required]="true"
                required
                placeholder="Select Service"
                multiple
              >
                <mat-option value="Construction">Construction</mat-option>
                <mat-option value="Renovation">Renovation</mat-option>
                <mat-option value="Maintenance">Maintenance</mat-option>
          
              </mat-select>
              <mat-error
                style="font-size: 15px; margin-left: 1%"
                *ngIf="companyservice.errors?.['required'] && (companyservice.touched || companyservice.dirty)"
              >
                Please select the service
              </mat-error>
            </div>
          </div> -->
  
          <!-- <div class="form-group" *ngIf="userinfo?.businesstype !== 'contract'">
            <label>Service provided<span style="color: red">*</span>:</label>
            <div
              style="
                margin: 0;
                width: 100%;
                background-color: #fbfbfb;
                padding: 5px 10px;
                border-radius: 5px;
                border: 1px solid #d4d4d4;
                position: relative;
                color: black;
              "
            >
              <mat-select
                style="height: inherit"
                id="companyservice"
                name="companyservice"
                [(ngModel)]="userinfo.accountdetails.companyservice"
                #companyservice="ngModel"
                maxlength="50"
                [required]="true"
                required
                placeholder="Select Service"
                
              >
              <mat-option value="Construction and Real Estate Services">Construction and Real Estate Services</mat-option>
              <mat-option value="Hospitality and Tourism Services">Hospitality and Tourism Services</mat-option>
              <mat-option value="Educational and Training Services">Educational and Training Services</mat-option>
      
              
      
              
                <mat-option value="Healthcare">Healthcare</mat-option>
                <mat-option value="Software Development">Software Development</mat-option>
                <mat-option value="Automobile service">Automobile service</mat-option>
      
                <mat-option value="IT Service">IT Service</mat-option>
                <mat-option value="Customer Care and Service">Customer Care and Service</mat-option>
                <mat-option value="Logistics and Transportation Services">Logistics and Transportation Services</mat-option>
                <mat-option value="Entertainment and Media Services">Entertainment and Media Services</mat-option>
                <mat-option value="Retail and Consumer Services">Retail and Consumer Services</mat-option>
                <mat-option value="Energy and Utility Services">Energy and Utility Services</mat-option>
                <mat-option value="Manufacturing and Production Services">Manufacturing and Production Services</mat-option>
                <mat-option value="Agriculture and Environmental Services">Agriculture and Environmental Services</mat-option>
                <mat-option value="Public Services">Public Services</mat-option>
      
               
              </mat-select>
              <mat-error
                style="font-size: 15px; margin-left: 1%"
                *ngIf="companyservice.errors?.['required'] && (companyservice.touched || companyservice.dirty)"
              >
                Please select the service
              </mat-error>
            </div>
          </div> -->
  
          
  
       
        
        </form>
        <button
        type="submit"
        class="btn-update"
        (click)="saveEditdetails(reqform)"
      >
        Update
      </button>
      </div>
    </div>
  </div>
  